import styled from 'styled-components'

import { WidgetInput } from '../widget-styles'

export const UnitPickerInput = styled(WidgetInput).attrs({ readOnly: true, 'aria-readonly': false })`
    user-select: none;
    cursor: pointer;
    width: 85%;
`
